<template>
  <div class="adminUserList">
    <Breadcumb :title="this.$t('attendanceMonitoring')" :breadcumb-data="breadcumbData">
    </Breadcumb>
    <b-card class="cardcontainer">
      <!-- Table controls -->
      <b-card-body>
        <template v-if="user.userprofile.participationlink && user.userprofile.participationlink != ''">
          <b-btn variant="primary  md-btn-flat" style="text-align:center; margin-left:auto; margin-right:auto; width:200px;display:block;"
                 :href="user.userprofile.participationlink" target="_blank">
            {{ $t('attendanceMonitoring') }}
          </b-btn>
        </template>
        <template v-else>
          <template v-for="company in user.userprofile.related_companies">
              <b-btn  variant="primary  md-btn-flat" style="text-align:center; margin-left:auto; margin-right:auto; width:200px;display:block; margin-bottom:20px;"
                    :href="company.participationlink" target="_blank">
              {{ $t('attendanceMonitoring') }} {{company.name }}
            </b-btn>
          </template>

        </template>
      </b-card-body>
    </b-card>
  </div>
</template>
<script>
import {mapState} from 'vuex';
import Breadcumb from '../components/breadcumb'
import {GET_REPORT_SURVEY_REQUEST, GET_RESULT_REQUEST} from "../_store/administration/result/actiontypes";
import slugify from 'slugify'

export default {
  name: 'adminUserList',
  components: {Breadcumb,},
  computed: mapState({user: state => state.user.user}),
  mounted() {
    this.breadcumbData = [
      {text: this.$t('welcome'), href: '/dashboard/'},
      {text: this.$t('attendanceMonitoring'), active: true},
    ];
  },
  data() {
    return {
      breadcumbData: [],
      fields: [],
      reportsData: [],
      currentPage: 1
    };
  },
  layout(context) {
    return 'layout';
  },
};
</script>
